import { render } from "./Overdue_Collections.vue?vue&type=template&id=29815da6"
import script from "./Overdue_Collections.vue?vue&type=script&lang=js"
export * from "./Overdue_Collections.vue?vue&type=script&lang=js"

import "./Overdue_Collections.vue?vue&type=style&index=0&id=29815da6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__